import React from "react";
import BlogsGrid from "../components/homepage/BlogsGrid";
import SideBar from "../components/homepage/SideBar";
import Wrapper from "../components/homepage/Wrapper";

export default function Home() {
  return (
    <Wrapper>
      <SideBar />
      <BlogsGrid />
    </Wrapper>
  );
}
